import { getSentimentLabels } from '@3fourteen/core';
import { useSentiment } from 'hooks/useSentiment';
import { memo, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { Card, RebalDate } from 'components';
import { CardProps } from 'components/Card/component';

interface SentimentCardProps {
  cardId: CardProps['cardId'];
}

function SentimentCard({ cardId }: SentimentCardProps) {
  const { sentiment } = useSentiment();

  const sentimentData = useMemo(() => {
    if (sentiment) {
      return getSentimentLabels(sentiment.currentValue);
    }
  }, [sentiment]);

  return (
    <Card
      cardId={cardId}
      heading='3FR Sentiment Index'
      href='/charts/sp-500-vs-3fourteen-research-daily-sentiment-index'
      leftEl={
        <div className='hidden lg:block'>
          <RebalDate date={sentiment?.date ?? ''} />
        </div>
      }>
      <div>
        {!sentimentData ? (
          <div className='p-4 md:p-6'>
            <Skeleton style={{ marginBottom: 0 }} />
          </div>
        ) : (
          <div className='flex items-center justify-center py-4 md:py-6 px-0.5 md:px-2'>
            <div
              className='rounded-sm h-6 md:h-7 lg:h-9 flex items-center justify-center px-2'
              style={{ backgroundColor: sentimentData.colorClass }}>
              <span
                data-testid='sentiment-reading'
                className='uppercase text-white text-center font-semibold md:py-1.5 md:px-0 text-xs lg:text-sm'>
                {sentimentData.label} ({sentiment!.currentValue.toFixed(1)})
              </span>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}

export default memo(SentimentCard);
